import React from 'react';
import styled from 'styled-components';
import { KEY_WITH_SCALE } from '../constants/animatedValues';

const Root = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;

  && .animated {
    animation: ${KEY_WITH_SCALE} 300ms ease;
    animation-fill-mode: both;
    animation-direction: normal;
  }
`;

const Logo = styled.img`
  width: 98.4px;
  height: 36.8px;
  margin: 0 24px;
  align-self: center;
  transform-origin: left center;
`;

type Props = {
  src: string;
  alt: string;
  setTabIndex?: (...args: any[]) => any;
};

const AnimatedLogo = ({ src, alt, setTabIndex }: Props) => (
  // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
  <Root onClick={(e) => setTabIndex(e, 0)}>
    <Logo className="to-be-animated" src={src} alt={alt} />
  </Root>
);

export default AnimatedLogo;
